import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { InfoBanner } from "@repo/ui/InfoBanner/infoBanner";
import type { FC } from "react";

export const PaywallBanner: FC = () => {
  return (
    <InfoBanner
      title={"Please upgrade to continue using Alpharun"}
      description={
        <>
          {
            "Your trial has expired and your company does not have an active subscription. Please upgrade to run new interviews and access insights. "
          }
          <div className="mt-4 flex space-x-4">
            <Button
              variant={ButtonVariant.Primary}
              onClick={() => {
                window.open("mailto:support@alpharun.com");
              }}
            >
              Contact us
            </Button>
            <Button
              variant={ButtonVariant.Secondary}
              onClick={() => {
                window.open("https://cal.frontapp.com/alpharun/paul/7fc09a3a");
              }}
            >
              Book a meeting
            </Button>
          </div>
        </>
      }
    />
  );
};
